import { toCamelCase } from '../changeCase';

const mapBodyToEntity = (response, entity) => {

    const data = response[entity] || {};
    const result = {};

    for (const id in data) {
        result[id] = toCamelCase(data[id]);
    }

    return result;
};

export default mapBodyToEntity;
